export default {"src":"/_next/static/media/whiteplus.86abd794.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};